import { useApplicationContext } from '../../utils/applicationContext';
import { EApplicationType } from '../../types/applicationContext';
import { useDailyrentNewReplySubmitHandler } from '../useDailyrentNewReplySubmitHandler';
import { useNewbuildingsNewReplySubmitHandler } from '../useNewbuildingsNewReplySubmitHandler';

type TSubmitHandlerHook = {
  (): () => void;
};

const defaultActionTypeHandler = () => () => {
  throw new Error('Текущее приложение имеет context.custom.applicationType === "default". Проверьте EApplicationType');
};

const SubmitNewReplyHandlerMap: Record<EApplicationType, TSubmitHandlerHook> = {
  [EApplicationType.Dailyrent]: useDailyrentNewReplySubmitHandler,
  [EApplicationType.Newbuildings]: useNewbuildingsNewReplySubmitHandler,
  [EApplicationType.Default]: defaultActionTypeHandler,
};

export const useNewReplySubmitHandler = () => {
  const context = useApplicationContext();
  const {
    custom: { applicationType },
  } = context;

  return SubmitNewReplyHandlerMap[applicationType]();
};
